import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { imgSrc, formatDate } from "@/lib/api";

export const NewsCard = ({ item, index = 0 }) => (
  <Link to={`/nyheter/${item.slug}`} data-testid={`news-card-${item.slug}`} className="group flex flex-col h-full">
    <div className="relative aspect-[16/11] overflow-hidden rounded-[22px] bg-[#070B2E]">
      {item.image_url ? (
        <img src={imgSrc(item.image_url)} alt={item.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
      ) : (
        <div className="absolute inset-0 grid place-items-center font-display text-6xl font-bold text-white/10">Redoc</div>
      )}
      <span className="absolute top-4 left-4 rounded-full bg-white/90 backdrop-blur px-3 py-1 font-mono text-[11px] uppercase tracking-[0.14em] text-[#0B14A0]">{item.category}</span>
    </div>
    <div className="pt-5 flex-1 flex flex-col">
      <p className="font-mono text-xs text-[#4A4F6E]">{formatDate(item.created_at)}</p>
      <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight mt-2 text-[#070B2E] group-hover:text-[#0B14A0] transition-colors">{item.title}</h3>
      {item.excerpt && <p className="mt-2 text-[#3A3F5C] leading-relaxed line-clamp-3">{item.excerpt}</p>}
      <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#0B14A0]">
        Läs mer <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </span>
    </div>
  </Link>
);
